<script>
    import Crawler from './crawler.js';
    import Output from './components/Output.svelte';
    import Options from './components/Options.svelte';
    import Catalog from './components/Catalog.svelte';
    import CategoryProduct from './components/CategoryProduct.svelte';
    import ProductPage from './components/ProductPage.svelte';

    const defaults = {
        // options
        separator: "|",
        timer: '100',
        timer_multiplier: 0,
        parse: {
            catalog: true,
            category: false,
            product: false,
        },
    
        url: '',
        only_one_cat: false,
    
        selector: {
            // category
            catalog: {
                element: '',
                link: '',
                title: '',
                image: '',
                image_outside: '',
                description: '',
                description_outside: '',
            },
        
            // product
            product: {
                element: '',
                link: '',
                title: '',
                image: '',
                description: '',
                price: '',
                vendorcode: '',
            },
        },
    }
    export let options = {};
    let params = Object.assign({}, defaults, options);
    
    const crawler = new Crawler();
    
    let content = false;
    let categories = [], products = [];

    const handler_share = () => {
        if (navigator.clipboard.writeText) {
            let b64 = btoa(unescape(encodeURIComponent(JSON.stringify(params))));
            navigator.clipboard.writeText(location.origin + '/?params=' + b64);
            toastbox('share-link', 1500);
        }
    };

    const change_url = (link, handler = null) => {
        let iframe = document.querySelector('iframe'),
            url = location.origin + '/proxy.php?url=' + link;
        
        if (link) {
            content = true;
            
            if (iframe.src !== url) {
                iframe.src = url;
                
                if (handler) {
                    iframe.onload = () => {
                        params.timer_multiplier = 0;
                        handler(iframe.contentWindow.document, iframe);
                    };
                }
                
                iframe.onerror = () => {
                    iframe.src = '';
                    content = false;
                    
                    // error go again after timer
                    setTimeout(() => change_url(url, handler), 10 + params.timer * params.timer_multiplier);
                    params.timer_multiplier++;
                };
            } else if (handler) {
                handler(iframe.contentWindow.document, iframe);
            }
        } else {
            content = false;
        }
    };

    const find_selector = (url, selector) => {
        if (url) {
            change_url(url, (doc) => {
                if (selector) {
                    let els = doc.querySelectorAll(selector);
            
                    els.forEach((el) => {
                        let style = el.style.border;
                        el.style.border = '3px solid red';
                        setTimeout(() => el.style.border = style, 1500);
                    });
                }
            });
        }
    };
    
    // сбор категорий в каталоге
    const parse_catalog = (url, parent = 0) => {
        return async (resolve) => {
            change_url(url, async (doc) => {
                for (let item of doc.querySelectorAll(params.selector.catalog.element)) {
                    let
                        link = params.selector.catalog.link.trim() ? item.querySelector(params.selector.catalog.link) : null,
                        title = params.selector.catalog.title.trim() ? item.querySelector(params.selector.catalog.title) : null,
                        image = params.selector.catalog.image.trim() ? item.querySelector(params.selector.catalog.image) : (params.selector.catalog.image_outside.trim() ? doc.querySelector(params.selector.catalog.image_outside) : null),
                        description = params.selector.catalog.description.trim() ? item.querySelector(params.selector.catalog.description) : (params.selector.catalog.description_outside.trim() ? doc.querySelector(params.selector.catalog.description_outside) : null);
    
                    let buf = {
                        index: categories.length + 1,
                        parent: parent,
                        link: link.getAttribute('href'),
                        title: title ? title.innerText : '',
                        description: description ? description.innerText : '',
                        image: image ? image.getAttribute('src') : '',
                    };
                    if (!categories.find(el => el.title === buf.title)) {
                        categories = categories.concat([buf]).sort((a, b) => a.parent < b.parent ? -1 : 1);
    
                        if (buf.link.replace('#', '')) {
                            crawler.prepend(parse_catalog(buf.link, buf.index));
                        }
                    }
                    if (params.only_one_cat) {
                        break;
                    }
                }
                
                await sleep(params.timer);
                resolve();
            });
        };
    };
    
    // тут мы проходим по собранным категориям
    // добавляем их в очередь для обработки продуктов
    const parse_category = () => {
        return async (resolve) => {
            for (let category of categories.reverse()) {
                crawler.prepend(parse_product(category.link, category.index));
            }
    
            await sleep(params.timer);
            resolve();
        };
    };
    
    // собсна обработчик продуктов
    const parse_product = (url, parent = 0) => {
        return async (resolve) => {
            change_url(url, async (doc) => {
                for (let product of doc.querySelectorAll(params.selector.product.element)) {
                    if (params.parse.product) {
                        let link = params.selector.product.link.trim() ? product.querySelector(params.selector.product.link) : null;
    
                        if (link) {
                            crawler.prepend(parse_product_page(link.getAttribute('href'), parent));
                        }
                    } else {
                        let title = params.selector.product.title.trim() ? product.querySelector(params.selector.product.title) : null,
                            image = params.selector.product.image.trim() ? product.querySelector(params.selector.product.image) : null,
                            price = params.selector.product.price.trim() ? product.querySelector(params.selector.product.price) : null,
                            description = params.selector.product.description.trim() ? product.querySelector(params.selector.product.description) : null,
                            vendorcode = params.selector.product.vendorcode.trim() ? product.querySelector(params.selector.product.vendorcode) : null;
    
                        let buf = {
                            index: products.length + 1,
                            parent,
                            title: title ? title.innerText : '',
                            price: price ? price.innerText : 0,
                            description: description ? description.innerText : '',
                            vendorcode: vendorcode ? vendorcode.innerText : '',
                            image: image ? image.getAttribute('src') : '',
                        };
                        if (!products.find(el => el.title === buf.title)) {
                            products = products.concat([buf]).sort((a, b) => a.parent < b.parent ? -1 : 1);
                        }
                    }
                }
    
                await sleep(params.timer);
                resolve();
            });
        };
    };
    
    const parse_product_page = (url, parent = 0) => {
        return async (resolve) => {
            change_url(url, async (doc) => {
                let title = params.selector.product.title.trim() ? doc.querySelector(params.selector.product.title) : null,
                    image = params.selector.product.image.trim() ? doc.querySelector(params.selector.product.image) : null,
                    price = params.selector.product.price.trim() ? doc.querySelector(params.selector.product.price) : null,
                    description = params.selector.product.description.trim() ? doc.querySelector(params.selector.product.description) : null,
                    vendorcode = params.selector.product.vendorcode.trim() ? doc.querySelector(params.selector.product.vendorcode) : null;
    
                let buf = {
                    index: products.length + 1,
                    parent,
                    title: title ? title.innerText : '',
                    price: price ? price.innerText : 0,
                    description: description ? description.innerText : '',
                    vendorcode: vendorcode ? vendorcode.innerText : '',
                    image: image ? image.getAttribute('src') : '',
                };
                if (!products.find(el => el.title === buf.title)) {
                    products = products.concat([buf]).sort((a, b) => a.parent < b.parent ? -1 : 1);
                }
    
                await sleep(params.timer);
                resolve();
            });
        };
    }
    
    const download_csv = () => {
        return async (resolve) => {
            if (params.parse.catalog && categories.length) {
                download('categories.csv', prepare_csv(categories, params.separator));
            }
            if (params.parse.category && products.length) {
                download('products.csv', prepare_csv(products, params.separator));
            }
    
            await sleep(params.timer);
            resolve();
        };
    };
    
    const handler_start = () => {
        // clear data
        categories = products = [];
        
        if (params.parse.catalog) {
            crawler.append(parse_catalog(params.url));
    
            if (params.parse.category) {
                crawler.append(parse_category());
            }
        } else {
            if (params.parse.category) {
                crawler.append(parse_product(params.url, 1));
            }
        }
        
        crawler.append(download_csv());
    };
</script>

<div class="appHeader bg-primary text-light">
    <div class="pageTitle">Парсер сайта</div>
    <div class="right d-none d-md-flex">
        {#if (navigator.clipboard.writeText) }
            <button type="button" class="btn btn-icon btn-outline-success" style="margin-right: 10px" on:click={handler_share}><i class="bi bi-share-fill"></i></button>
        {/if}
        <button type="button" class="btn btn-success" on:click={handler_start}>Начать процесс</button>
    </div>
</div>

<div id="appCapsule" class="full-height">
    <div class="section full">
        <div class="row d-none d-md-flex">
            <div class="col-md-4 col-lg-3" style="border-right: 1px solid #E1E1E1; padding-right: 0;">
                <div style="height: calc(100vh - 50px); overflow-y: scroll">
                    <Options
                        bind:url={params.url}
                        bind:separator={params.separator}
                        bind:timer={params.timer}
                        bind:parse_catalog={params.parse.catalog}
                        bind:parse_category={params.parse.category}
                        bind:parse_product={params.parse.product}
                        {change_url}
                    />
    
                    {#if params.parse.catalog}
                        <Catalog
                            bind:only_one_cat={params.only_one_cat}
                            bind:selector_catalog_element={params.selector.catalog.element}
                            bind:selector_catalog_link={params.selector.catalog.link}
                            bind:selector_catalog_title={params.selector.catalog.title}
                            bind:selector_catalog_image={params.selector.catalog.image}
                            bind:selector_catalog_image_outside={params.selector.catalog.image_outside}
                            bind:selector_catalog_description={params.selector.catalog.description}
                            bind:selector_catalog_description_outside={params.selector.catalog.description_outside}
                            {change_url}
                            {find_selector}
                        />
                    {/if}
                    {#if params.parse.category}
                        {#if params.parse.product}
                            <ProductPage
                                bind:selector_product_page_element={params.selector.product.element}
                                bind:selector_product_page_link={params.selector.product.link}
                                bind:selector_product_page_title={params.selector.product.title}
                                bind:selector_product_page_image={params.selector.product.image}
                                bind:selector_product_page_description={params.selector.product.description}
                                bind:selector_product_page_price={params.selector.product.price}
                                bind:selector_product_page_vendorcode={params.selector.product.vendorcode}
                                {change_url}
                                {find_selector}
                            />
                        {:else}
                            <CategoryProduct
                                bind:selector_category_product_element={params.selector.product.element}
                                bind:selector_category_product_title={params.selector.product.title}
                                bind:selector_category_product_image={params.selector.product.image}
                                bind:selector_category_product_description={params.selector.product.description}
                                bind:selector_category_product_price={params.selector.product.price}
                                bind:selector_category_product_vendorcode={params.selector.product.vendorcode}
                                {change_url}
                                {find_selector}
                            />
                        {/if}
                    {/if}
                </div>
            </div>
            <div class="col-md-8 col-lg-9 overflow-hidden" style="padding-left: 0; padding-right: 0;">
                <Output {content} {categories} {products} />
            </div>
        </div>
        
        <div class="row my-5 d-md-none">
            <div class="col-12 text-center">
                <h3>Упс</h3>
                Работа с парсером возможна только на широком экране
            </div>
        </div>
    </div>
</div>

<!-- Share -->
<div id="share-link" class="toast-box toast-top bg-primary">
    <div class="in">
        <div class="text">
            Скопирована ссылка на парсер с параметрам
        </div>
    </div>
</div>
<!-- * Member toasts -->
